<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Appoint Appraisal Authority</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" @change="getAuthorities()" />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Authority Type</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="authority_type" :items="authority_type_list"
              item-text="name" item-value="id" label="Authority Type" outlined persistent-hint
              hint="Please Select Authority Type" />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Employee</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" :items="instructor_list"
              item-text="name" item-value="id" label="Employee" outlined multiple persistent-hint
              hint="Please Select Employee">
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-checkbox @change="togglemethod(instructor)" v-model="selected_toggle"></v-checkbox>
                  <v-list-item-content>
                    <v-list-item-title>
                      Select All
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="ay && authority_type && instructor">
          <v-btn color="warning" @click="saveAppraisalAuthorityInstructor()">Save</v-btn>
        </v-row>
      </v-card>

      <v-card class="box" v-if="appraisal_authority_type_instructor_list != ''">
        <v-data-table :headers="headers" :items="appraisal_authority_type_instructor_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Appoint Appraisal Authority</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.isactive`]="{ item }">
            <v-switch v-model="item.isactive" @change="saveAppraisalAuthorityInstructorIsactive(item)"></v-switch>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
    snackbar: false,
    // extraBreadcrumbItems: [
    //   { text: "Appraisal Authority", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
      overlay: false,
      ay_list:[],ay:"",authority_type_list:[],authority_type:"",instructor_list:[],instructor:"",appraisal_authority_type_instructor_list:[],
      headers:[
      { text: "Sr no", value: "count" },
      { text: "Authority Type", value: "selfappriasalauthoritytype" },
      { text: "Employee", value: "instructor" },
      { text: "Is active ?", value: "isactive" },
      ],
      selected_toggle: false,
  }),
   methods: {
    getAuthorities(){
      this.appraisal_authority_type_instructor_list=[]
      const data = {
        ay: this.ay,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/SelfAppriasalMaster/getAuthoritylinkingByAY", data)
        .then((res) => {
          if (res.data.flag == "YES") {
           (this.appraisal_authority_type_instructor_list = res.data.appraisal_authority_type_instructor_list)
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          //this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    togglemethod() {
          if (this.selected_toggle) {
              this.instructor = this.instructor_list.map(
                  (inst) => inst.id
              );
          } else {
              this.instructor = [];
          }
      },
    saveAppraisalAuthorityInstructorIsactive(item){
      const data = {
        section_id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/SelfAppriasalMaster/saveAppraisalAuthorityInstructorIsactive", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("success", "Status Updated Successfully...");
          } else if (res.data.flag == "NO") {
            this.showSnackbar("error", "something went wrong...");
          }
          this.overlay = false;
        })
        .catch((error) => {
          //this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    saveAppraisalAuthorityInstructor(){
      const data = {
        ay: this.ay,
        authority_type: this.authority_type,
        instructor: this.instructor.map(
                    (inst) => (typeof inst === "object" ? inst.id : inst)
                ),
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/SelfAppriasalMaster/saveAppraisalAuthorityInstructor", data)
        .then((res) => {
          if (res.data.flag == "YES") {
           (this.appraisal_authority_type_instructor_list = res.data.appraisal_authority_type_instructor_list)
            this.showSnackbar("green", "Authority Appointed Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          //this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
      onLoad() {
        axios
            .post("SelfAppriasalMaster/appointAppraisalAuthority")
            .then((res) => {
                if (res.data.flag == "YES") {
                    (this.ay_list = res.data.ay_list),
                    (this.appraisal_authority_type_instructor_list = res.data.appraisal_authority_type_instructor_list),
                    (this.authority_type_list = res.data.authority_type_list),
                    (this.instructor_list = res.data.instructor_list),
                     (this.ay = res.data.current_ay);
                    this.overlay = false;
                } else {
                    this.showSnackbar("#b71c1c", res.data.status_reason);
                }
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                this.overlay = false;
            })
            .finally(() => {
                this.overlay = false;
            });
            },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>